import { inject, Injectable } from '@angular/core';
import { UrlResolverService } from '../url/url-resolver.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  // Services
  private readonly urlResolver = inject(UrlResolverService);

  // Methods
  /**
   * Resolves a backend download/open link to an absolute URL and opens it in the current tab.
   * Relative paths resolve against BACKEND_URL; absolute http(s) URLs are opened unchanged.
   * @param link the backend-relative or absolute link to open
   */
  openDownloadLink(link?: string): void {
    const url = this.urlResolver.resolveUrl(link, 'backend');
    if (url) {
      window.open(url, '_self');
    }
  }
}
